import { useServicesCategories } from '@/features/services/hooks';
import { useServicesList } from '@/features/services/hooks/use-services-list';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { Spinner } from '@/components/ui/spinner';

import { ServicesCommingSoon } from '../comming-soon';
import { ServicesEmptyState } from '../empty-state';
import { ServicesItems } from '../items/items';

export function ServicesContent() {
  const { data: services, isLoading } = useServicesList();
  const {
    categories: allTabsCategories,
    kv: categoriesKv,
    normalizedServicesCategories: servicesCategories,
  } = useServicesCategories();

  if (isLoading) {
    return (
      <div className="flex h-96 items-center justify-center">
        <Spinner className="text-primary-700 size-10" />
      </div>
    );
  }

  if (!services) return null;
  if (servicesCategories.length === 0) return <ServicesCommingSoon />;
  if (services.length === 0) return <ServicesEmptyState />;

  const servicesInPublishedCategories = services.filter((service) => allTabsCategories.includes(service.category));

  return (
    <Tabs defaultValue={allTabsCategories[0]}>
      <TabsList variant="line" className="w-full overflow-x-auto overflow-y-hidden border-b border-gray-300 lg:w-1/2">
        {allTabsCategories.map((category) => (
          <TabsTrigger key={category} value={category} className="cursor-pointer">
            {categoriesKv[category]}
          </TabsTrigger>
        ))}
      </TabsList>

      {allTabsCategories.map((category) => (
        <TabsContent key={category} value={category}>
          <ServicesItems
            services={
              category === 'all'
                ? servicesInPublishedCategories
                : servicesInPublishedCategories.filter((s) => s.category === category)
            }
          />
        </TabsContent>
      ))}
    </Tabs>
  );
}
